var React = require('react');

function Add (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22Z","fill":"#D6F5FF","fillOpacity":"0.3","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22 42C33.0457 42 42 33.0457 42 22C42 10.9543 33.0457 2 22 2C10.9543 2 2 10.9543 2 22C2 33.0457 10.9543 42 22 42ZM22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z","fill":"currentColor","key":1}),React.createElement("path",{"d":"M20.6767 23.3521H16V20.7082H20.6767V16H23.3233V20.7082H28V23.3521H23.3233V28H20.6767V23.3521Z","fill":"currentColor","key":2})]);
}

Add.defaultProps = {"viewBox":"0 0 44 44","fill":"none","style":{"color":"#20BBE6"}};

module.exports = Add;

Add.default = Add;
